import { resolveGsbHost, type GsbHostResolution } from "@gsb-core/app-kit";

export function resolveWorkspaceHost(
  hostname: string,
  baseDomain: string,
): GsbHostResolution {
  if (hostname === `console.${baseDomain}`) {
    return { surface: "workspace-selector" };
  }
  return resolveGsbHost(hostname, {
    accountHost: `account.${baseDomain}`,
    baseHost: baseDomain,
    workspaceSelectorHost: `workspace.${baseDomain}`,
  });
}

export function resolveWorkspaceTenantCode(
  hostname: string,
  localTenantCode?: string,
  baseDomain = "localhost",
): string | undefined {
  if (hostname.endsWith(".localhost")) {
    return resolveGsbHost(hostname, {
      baseHost: "localhost",
    }).tenantCode;
  }
  const resolution = resolveWorkspaceHost(hostname, baseDomain);
  return (
    resolution.tenantCode ??
    (hostname === "localhost" ? localTenantCode : undefined)
  );
}
